<template>
    <q-select
        :dark="$store.state.darkMode"
        class="regularFontSize color__blackOnDisabled"
        popup-content-class="regularFontSize"
        outlined
        dense
        options-dense
        :options-dark="$store.state.darkMode"
        behavior="menu"
        use-input
        transition-hide="jump-up"
        transition-show="jump-down"
        input-debounce="0"
        :popup-content-style="{
            width: '100px',
        }"
        @filter="filterElements"
        :disable="disable"
        :label="label"
        :options="customOptions"
        v-model="input"
        @input="onChange"
        :error="error"
        hide-hint
        hide-bottom-space
        :rules="rules"
    >
        <template v-if="input" v-slot:append>
            <q-icon size="xs" style="color: lightgray" name="cancel" @click.stop.prevent="clearFields" class="cursor-pointer" />
        </template>
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
       
    </q-select>
</template>

<script>
export default {
    props: ['disable', 'label', 'model', 'value', 'options', 'error', 'loading', 'rules', 'isOptionSlot'],
    mounted() {
        this.input = this.value;
        this.customOptions = this.options;
        this.filteredOptions = this.customOptions;
    },
    data() {
        return {
            input: '',
            filteredOptions: [],
            customOptions: [],
            regionSearch: '',
        };
    },
    methods: {
        clearFields() {
            this.input = '';
            this.$emit('change', this.model, this.input);
        },
        onChange() {
            this.$emit('change', this.model, this.input);
            if (this.label.toLowerCase().includes('warehouse')) {
                this.$emit('input', this.input);
            }
        },

        filterElements(val, update) {
            update(() => {
                const needle = (val || '').toLowerCase().trim();

                if (!needle) {
                    this.customOptions = [...this.filteredOptions];
                    return;
                }

                this.customOptions = this.filteredOptions.filter((item) =>
                     String(item).toLowerCase().includes(needle)
                );
            });
        },

        setoptions(setopt) {
            this.customOptions = setopt || [];
        },

        setValue(val) {
            this.input = val;
        },
        handleFocus() {
            this.$refs.inputRef.focus();
        },
        required(value) {
            return !!value || 'This field is required';
        },
    },
    watch: {
        options(newVal) {
            // Update dropdown options
            this.customOptions = newVal;

            // Also update the list used for filtering
            this.filteredOptions = [...newVal];

            // Debug
        },
        value(newVal) {
            this.input = newVal;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/quasar.variables.scss';
</style>
